<button class="bg-transparent outline-0 border-0 blue fw-bold mb-4" (click)="action($event)">
    <img src="assets/images/apartmentImages/ic_baseline-add.svg" />
    {{text}}
  </button>
  